import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LIVE_LINK } from "../helpers/url_helper";
export const priorityUAEApi = createApi({
  reducerPath: "priorityUAEApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${LIVE_LINK}/priority` }),
  tagTypes: ["priorityUAE"],
  refetchOnFocus: true,
  endpoints: (build) => ({
    fetchAllPriorityUAE: build.query({
      query: () => ({
        url: "/priority-uae",
      }),
      providesTags: (result) =>
        result?.priorityUAE
          ? [
              ...result.priorityUAE.map(({ _id }) => ({
                type: "priorityUAE",
                id: _id,
              })),
              { type: "priorityUAE", id: "LIST" },
            ]
          : [{ type: "priorityUAE", id: "LIST" }],
    }),
    addPriorityUAE: build.mutation({
      query: (newRow) => ({
        url: "/priority-uae",
        method: "POST",
        body: newRow,
      }),
      async onQueryStarted(newRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityUAEApi.util.updateQueryData("fetchAllPriorityUAE", undefined, (draft) => {
            draft.priorityUAE.push(newRow); // Optimistically add the new row to the list
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic addition on failure
        }
      },
      invalidatesTags: [{ type: "priorityUAE", id: "LIST" }],
    }),
    updatePriorityUAE: build.mutation({
      query: (updatedRow) => ({
        url: `priority-uae/${updatedRow._id}`,
        method: "PUT",
        body: updatedRow,
      }),
      async onQueryStarted(updatedRow, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityUAEApi.util.updateQueryData("fetchAllPriorityUAE", undefined, (draft) => {
            const item = draft.priorityUAE.find((row) => row._id === updatedRow._id);
            if (item) {
              Object.assign(item, updatedRow); // Apply changes optimistically
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic update on failure
        }
      },
      invalidatesTags: (result, error, updatedRow) => {
        return [
          { type: "priorityUAE", id: updatedRow._id },
          { type: "priorityUAE", id: "LIST" },
        ];
      },
    }),
    deletePriorityUAE: build.mutation({
      query: (id) => ({
        url: `priority-uae/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          priorityUAEApi.util.updateQueryData("fetchAllPriorityUAE", undefined, (draft) => {
            const index = draft.priorityUAE.findIndex((row) => row._id === id);
            if (index !== -1) {
              draft.priorityUAE.splice(index, 1); // Remove item optimistically
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo(); // Revert optimistic deletion on failure
        }
      },
      invalidatesTags: (result, error, id) => [
        { type: "priorityUAE", id },
        { type: "priorityUAE", id: "LIST" },
      ],
    }),
    getLogsByOrderId: build.query({
      query: (orderId) => ({
        url: `/logbook/${orderId}`,
        method: "GET",
      }),
    }),
  }),
});
